import gql from 'graphql-tag';
import React, { useContext, useState } from 'react';
import { useMutation, useQuery } from 'react-apollo-hooks';
import { NotebookContext } from '../../../../context/NotebookContext';
import { trackerCreateOrUpdateMutation } from '../../../../queries/trackers';
import {
  TrackerCreateOrUpdateMutation,
  TrackerCreateOrUpdateMutationVariables
} from '../../../../queries/__generated__/TrackerCreateOrUpdateMutation';
import { Switch } from '../../../forms';
import { Icon } from '../../../ui';
import { Tracker } from '../types';
import EditTrackerModal from '../../../EditTrackerModal';

interface TrackerToggleProps {
  tracker: Tracker;
  userCanAdmin: boolean;
}

const TrackerToggle: React.FC<TrackerToggleProps> = ({ tracker, userCanAdmin }) => {
  const { notebook } = useContext(NotebookContext);
  const [showEditModal, setShowEditModal] = useState(false);

  const toggleTracker = useMutation<
    TrackerCreateOrUpdateMutation,
    TrackerCreateOrUpdateMutationVariables
  >(trackerCreateOrUpdateMutation, {
    variables: {
      input: { notebookId: notebook.id, id: tracker.id, active: !tracker.active }
    }
  });

  return (
    <>
      <li
        key={tracker.id}
        data-testid={tracker.slug}
        className="flex items-center justify-between pv2 bt b--light-gray"
      >
        <span className="flex items-center">
          <span className="f6 mr1">{tracker.name}</span>
          {userCanAdmin && (
            <button onClick={() => setShowEditModal(true)}>
              <Icon name="edit" size={16} />
            </button>
          )}
        </span>
        <Switch active={tracker.active} onClick={toggleTracker} disabled={!userCanAdmin} />
      </li>
      {showEditModal && (
        <EditTrackerModal tracker={tracker} closeModal={() => setShowEditModal(false)} />
      )}
    </>
  );
};

export default TrackerToggle;
